<template>
  <div class="home-container">
    <div class="main-content">
      <div class="post-list">
        <div class="c-l-header">
          <CategorySelect 
            v-model="selectedCategory" 
            placeholder="全部分类"
            size="small"
            custom-style="width: 200px; margin-right: 10px;"
            @change="getCategoryPosts"
          />
          <div class="new btn-iconfont" :class="{ active: timeOrder }" @click="selectOrder('time')">
            <i class="iconfont icon-polygonred"></i>New
          </div>
          <div class="top btn-iconfont" :class="{ active: scoreOrder }" @click="selectOrder('score')">
            <i class="iconfont icon-top"></i>Score
          </div>
          <div class="search">
            <i class="search-icon el-icon-search" @click="searchPost"></i>
            <input type="text" class="s-input" v-model="keyword" @keydown.enter="searchPost" placeholder="文章搜索" />
          </div>
          <div class="publish-btn" @click="goPublish">发表</div>
        </div>
        <ul class="c-l-list" ref="postListContainer">
          <li class="c-l-item" v-for="post in postList" :key="post.docDigest || post.post_id">
            <div class="l-container" @click="goDetail(post.docDigest || post.post_id)">
              <h4 class="con-title">{{ post.title }}</h4>
              <div class="con-memo">
                <p>{{ post.title }}</p>
              </div>
              <div class="post-meta">
                <span class="meta-item">
                  <i class="el-icon-user"></i>
                  {{ post.createUserName || '未知作者' }}
                </span>
                <span class="meta-item">
                  <i class="el-icon-time"></i>
                  {{ post.createTime || '' }}
                </span>
                <span class="meta-item">
                  <i class="el-icon-star-on"></i>
                  {{ post.praiseCount || 0 }}
                </span>
                <span class="meta-item">
                  <i class="el-icon-chat-dot-round"></i>
                  {{ post.commentCount || 0 }}
                </span>
              </div>
            </div>
          </li>
          <div class="loading-status" v-if="loading">
            <i class="el-icon-loading"></i>
            <span>加载中...</span>
          </div>
          <el-empty v-if="postList.length > 0 && !hasMore" description="没有更多了" :image-size="80"></el-empty>
          <div class="load-more-container" v-if="hasMore && postList.length > 0">
            <el-button type="primary" @click="loadMore" :loading="loading" plain>
              加载更多
            </el-button>
          </div>
        </ul>
      </div>

      <div class="sidebar">
        <DocRankList :categoryId="1" :limit="10" />
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import DocRankList from './components/DocRankList.vue';
import CategorySelect from '../components/CategorySelect.vue';
export default {
  name: "Home",
  components: {
    DocRankList,
    CategorySelect
  },
  data() {
    return {
      order: "time",
      postList: [],
      pageNumber: 1,
      pageSize: 10,
      pageTotal: 0,
      keyword: '',
      isSearch: false,
      selectedCategory: 0,
      hasMore: true,
      loading: false
    };
  },
  created() {
    this.getPostList();
  },
  methods: {
    goDetail(id) {
      this.$router.push({ name: "Content", params: { id: id } });
    },
    getPostList() {
      this.loading = true;
      this.$axios({
        method: "post",
        url: "/doc/queryUserDocList",
        data: {
          pageNum: this.pageNumber,
          pageSize: this.pageSize,
          order: this.order,
          categoryId: this.selectedCategory === 0 ? null : this.selectedCategory,
          includeSubCategories: true,
          keyword: this.keyword || null
        }
      })
          .then(response => {
            this.loading = false;
            console.log(response.data, 222);
            if (response.code == 200) {
              const newList = response.data.data || [];
              this.pageTotal = response.data.total || 0;
              
              if (this.pageNumber === 1) {
                this.postList = newList;
              } else {
                this.postList = [...this.postList, ...newList];
              }
              
              this.hasMore = this.postList.length < this.pageTotal;
            } else {
              this.notify_tip("提示", response.msg)
            }
          })
          .catch(error => {
            this.loading = false;
            console.log(error);
          });
    },
    getCategoryPosts() {
      this.pageNumber = 1;
      this.postList = [];
      this.hasMore = true;
      this.getPostList();
    },
    selectOrder(order) {
      this.order = order;
      this.pageNumber = 1;
      this.postList = [];
      this.hasMore = true;
      this.getPostList();
    },
    handleScroll() {
      if (this.loading || !this.hasMore) return;
      
      // 检查是否有下拉框处于打开状态
      const dropdown = document.querySelector('.el-select-dropdown');
      if (dropdown && dropdown.offsetParent !== null) {
        return;
      }
      
      const container = this.$refs.postListContainer;
      if (!container) return;
      
      const scrollTop = container.scrollTop;
      const clientHeight = container.clientHeight;
      const scrollHeight = container.scrollHeight;
      
      if (scrollTop + clientHeight >= scrollHeight - 300) {
        this.pageNumber++;
        this.getPostList();
      }
    },
    handleCurrentChange(val) {
      this.pageNumber = val;
      if (!this.isSearch) {
        this.getPostList();
      } else {
        this.searchPost();
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      if (!this.isSearch) {
        this.getPostList();
      } else {
        this.searchPost();
      }
    },
    loadMore() {
      if (this.loading || !this.hasMore) return;
      this.pageNumber++;
      this.getPostList();
    },
    goPublish() {
      this.$router.push({ name: "Publish" });
    },
    notify_tip(data_title,msg) {
      const h = this.$createElement;

      this.$notify({
        title: data_title,
        message: h('i', { style: 'color: teal'}, msg)
      });
    },
    async searchPost() {
      this.isSearch = true;
      this.pageNumber = 1;
      this.postList = [];
      this.hasMore = true;
      this.getPostList();
    },
    beforeDestroy() {
      const container = this.$refs.postListContainer;
      if (container) {
        container.removeEventListener('scroll', this.handleScroll);
      }
    }
  },
  computed: {
    timeOrder() {
      return this.order == "time";
    },
    scoreOrder() {
      return this.order == "score";
    }
  }
};
</script>
<style scoped lang="less">
.home-container {
  min-height: calc(100vh - 64px);
  margin-top: 64px;
  background: linear-gradient(to right, #A7BFE8, #6190E8);
  padding-top: 10px;

  .main-content {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    gap: 20px;
    align-items: flex-start;

    .post-list {
      flex: 1;
      min-width: 0;
      overflow: auto;
      padding-right: 8px;

      &::-webkit-scrollbar {
        width: 0;
        height: 0;
        display: none;
      }

      .c-l-header {
        align-items: center;
        background-color: #ffffff;
        border: 1px solid #ccc;
        border-radius: 4px;
        box-sizing: border-box;
        display: flex;
        flex-flow: row nowrap;
        height: 56px;
        justify-content: flex-start;
        margin-bottom: 16px;
        padding: 0 12px;

        .iconfont {
          margin-right: 4px;
        }

        .btn-iconfont {
          display: flex;
        }

        .active {
          background: #f6f7f8;
          color: #0079d3;
          fill: #0079d3;
          border-radius: 20px;
          height: 32px;
          line-height: 32px;
          margin-right: 8px;
          padding: 0 10px;
        }

        .new {
          font-size: 14px;
          margin-right: 18px;
        }

        .top {
          font-size: 14px;
        }

        .search {
          flex-grow: 0.5;
          margin: 0 auto;
          max-width: 650px;
          position: relative;
          display: flex;
          align-items: center;
          border-radius: 4px;

          .search-icon {
            width: 18px;
            height: 18px;
            line-height: 18px;
            background-size: cover;
            display: inline-block;
            position: absolute;
            cursor: pointer;
            border-radius: 4px;
            right: 1rem;
            padding: 5px;

            &:hover {
              background: silver;
            }
          }

          .s-input {
            flex-grow: 1;
            -webkit-appearance: none;
            appearance: none;
            background-color: #f6f7f8;
            border-radius: 4px;
            border: 1px solid #edeff1;
            box-shadow: none;
            color: #c1c1c1;
            display: block;
            height: 36px;
            outline: none;
            width: 100%;
            text-indent: 1rem;
          }
        }

        .publish-btn {
          width: fit-content;
          height: fit-content;
          border: 1px solid transparent;
          border-radius: 4px;
          box-sizing: border-box;
          text-align: center;
          letter-spacing: 1px;
          text-decoration: none;
          font-size: 12px;
          font-weight: 700;
          letter-spacing: 0.5px;
          line-height: 24px;
          text-transform: uppercase;
          padding: 3px 16px;
          fill: #0079d3;
          display: inline-block;
          cursor: pointer;
          border-color: #0079d3;
          background: #0079d3;
          color: #fff;

          &:nth-child(2) {
            margin: 0 10px;
          }
        }

        .sort {
          margin-left: 300px;
          display: flex;
          color: #0079d3;
          align-items: center;

          .sort-triangle {
            width: 0;
            height: 0;
            border-top: 5px solid #0079d3;
            border-right: 5px solid transparent;
            border-bottom: 5px solid transparent;
            border-left: 5px solid transparent;
            margin-top: 5px;
            margin-left: 10px;
          }
        }
      }

      .c-l-list {
        .c-l-item {
          list-style: none;
          border-radius: 8px;
          cursor: pointer;
          border: 1px solid #e8e8e8;
          margin-bottom: 12px;
          background-color: rgba(255, 255, 255, 0.95);
          color: #878a8c;
          position: relative;
          transition: all 0.3s ease;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);

          &:hover {
            box-shadow: 0 4px 16px rgba(102, 126, 234, 0.15);
            border-color: #667eea;
            transform: translateY(-2px);
          }

          .l-container {
            flex: 1;
            padding: 16px 20px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            .con-title {
              color: #333;
              font-size: 18px;
              font-weight: 600;
              line-height: 26px;
              text-decoration: none;
              word-break: break-word;
              margin: 0 0 10px;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              overflow: hidden;
              transition: color 0.2s;

              &:hover {
                color: #667eea;
              }
            }

            .con-memo {
              margin: 0 0 12px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              color: #666;
              font-size: 14px;
              line-height: 22px;

              p {
                margin: 0;
              }
            }

            .post-meta {
              display: flex;
              align-items: center;
              gap: 16px;
              flex-wrap: wrap;
              color: #999;
              font-size: 13px;

              .meta-item {
                display: flex;
                align-items: center;
                gap: 4px;

                i {
                  color: #667eea;
                  font-size: 14px;
                }
              }
            }
          }
        }

        .loading-status {
          text-align: center;
          padding: 20px;
          color: #999;
          font-size: 14px;

          i {
            margin-right: 8px;
          }
        }

        .load-more-container {
          display: flex;
          justify-content: center;
          padding: 20px 0;
        }
      }
    }

    .sidebar {
      width: 320px;
      flex-shrink: 0;

      ::v-deep .rank-card,
      ::v-deep .user-rank-card {
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        margin-bottom: 16px;
      }
    }
  }
}

@media (max-width: 1200px) {
  .home-container {
    .main-content {
      flex-direction: column;

      .sidebar {
        width: 100%;
      }
    }
  }
}
</style>
